import React from 'react'
import Subject from './Subject'
import cse from '../assets/CSE407end21.pdf'

export default function OopsLab() {
  return (
    <div>
       <Subject title="Object Oriented Programming Lab(CSE407)" sub="OOPS_LAB" syllabus="#"
    book1="--NIL--"
    book1Link="#" int21="#" mid21="#" end21={cse}
     int20="#" mid20="#" end20="#"
    />
    </div>
  )
}
